<template>
  <div>
    <template v-if="node.hasOwnProperty('children') && node.children.length">
      <div class="row align-items-center pl-4 py-0">
        <h6 class="h6 text-uppercase" style="font-weight: bold">SECTION {{node.code}}: {{node.main_question}}</h6>
      </div>
      <template v-for="(node,index) in node.children">
        <RsncQuestionComponent :node="node" :rsnc-code="rsncCode" :dept="index" @setQuestion="(item)=>$emit('setQuestion',item)"></RsncQuestionComponent>
      </template>
    </template>
    <template v-else>
      <div class="form-check form-check-inline align-items-start d-flex pb-1 pl-3">
        <input
          class="form-check-input expand-25-percent mr-2 custom-checkbox"
          type="checkbox"
          :id="node.id"
          :value="node.id"
          :disabled="!(rsncCode && rsncCode.id !== node.id)"
          @change="selectQuestion(node)"
          :checked="parseInt(rsncCode.id) === parseInt(node.id)"
        >

        <label :for="node.id" class="form-check-label d-inline-flex flex-wrap">
    <span
      :style="{ fontWeight: isSelected(node.id) ? 'bold' : '' }"
      class="mr-1"
    >
      {{ node.code }}
    </span>
          <span
            v-html="node.main_question"
            :style="{ fontWeight: isSelected(node.id) ? 'bold' : '' }"
          ></span>
        </label>
      </div>
    </template>
  </div>
</template>

<style scoped>
.custom-checkbox {
  appearance: none;
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;
  min-height: 16px !important;
  border: 2px solid #ccc;
  border-radius: 4px;
  position: relative;
}

.custom-checkbox:disabled {
  background-color: #007bff;
  border-color: #007bff;
}

.custom-checkbox:checked::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.custom-checkbox:disabled {
  opacity: 1; /* Don't gray it out */
}
</style>

<script>
import PscActionCodeComponent from "@/components/modules/psc/deficiency/PscActionCodeComponent.vue";

export default {
  name: "RsncQuestionComponent",
  components: {PscActionCodeComponent},
  props: {
    node: Object,
    dept:0,
    rsncCode:Object
  },
  methods: {
    selectQuestion(value) {
      this.$emit('setQuestion', value);
    },
    isSelected(id) {
      return parseInt(this.rsncCode?.id) === parseInt(id);
    }
  }
}
</script>
